import { render } from "./ScanHistory.vue?vue&type=template&id=ba0f3b88&scoped=true"
import script from "./ScanHistory.vue?vue&type=script&lang=js"
export * from "./ScanHistory.vue?vue&type=script&lang=js"

import "./ScanHistory.vue?vue&type=style&index=0&id=ba0f3b88&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba0f3b88"]])

export default __exports__